/* global Modernizr */

var App = App || {};

App.CourseListing = (function ($) {
    "use strict";

    var _dataSource;

    function init() {
        $("#course_template").load("/UserControls/CourseListing/CourseTemplate.tmpl.htm", function () {
            kendo.ui.progress.messages = {
                loading: "Loading course data..."
            };

            var template = kendo.template($("#course_template").html());

            _dataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: "/customapi/courses",
                        dataType: "json"
                    }
                },
                requestStart: function () {
                    kendo.ui.progress($("#course_tiles"), true);
                },
                requestEnd: function () {
                    kendo.ui.progress($("#course_tiles"), false);
                },
                change: function () {
                    $("#course_tiles").html(kendo.render(template, this.view()));
                }
            });

            _dataSource.read();
        });
    }

    function filterRole(role) {
        if (role && role != 'All') {
            _dataSource.filter({
                field: "Roles",
                operator: function (item, value) {
                    return ($.inArray(role, item) > -1)
                }
            });
        } else {
            _dataSource.filter([]);
        }
    }

    return {
        init: init,
        filterRole: filterRole

    };
})(jQuery);

$(function () {
    App.CourseListing.init();
});